import { useSelector } from 'react-redux';
import { selectFeatures } from '../store/slices/featureSlice';
import { checkFeature } from '../utils/featureFlag';

export const useFeatureFlag = (featureName: string): boolean => {
    const featureFlags = useSelector(selectFeatures);

    return !!checkFeature('', { featureName }, featureFlags?.features);
};
